const isEmail = (email) => {
  return /.+@.+\.[A-Za-z]+$/.test(email)
}

export default isEmail
